import React, { Component } from 'react';
import ReactImageMagnify from 'react-image-magnify';
import _ from 'lodash';

export default class ImageMagnifier extends Component {
  constructor(props) {
    super(props);

    this.scale = 2;

    this.state = {
      loaded: false,
    };
  }

  setMagnifierConfig = dimensions => {
    const { width, height } = dimensions;
    const { smallImage, largeImage } = this.props;
    return {
      loaded: true,
      magnifier: {
        smallImage: {
          ...smallImage,
          isFluidWidth: true,
          height,
          width,
        },
        largeImage: {
          ...largeImage,
          src: _.get(this.props, 'largeImage.src', smallImage.src),
          height: height * this.scale,
          width: width * this.scale,
        },
      },
    };
  };

  load = ({ target: img }) => {
    const dimensions = {
      height: img.offsetHeight,
      width: img.offsetWidth,
    };

    this.setState(this.setMagnifierConfig(dimensions));
  };

  render() {
    const { loaded, magnifier } = this.state;
    const { smallImage } = this.props;
    return (
      <div className="image-magnifier">
        {loaded && <ReactImageMagnify {...magnifier} imageClassName="image-magnifier__image" />}
        <img
          className="image-magnifier__hidden"
          alt="magnified"
          src={smallImage.src}
          onLoad={this.load}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageMagnifier.js